module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/fire-eaba6f2d3ac02f78fda845ebf9c0dc0f.svg";